import { ShieldCheck } from "lucide-react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import type { MerchantReview } from "@/interfaces/review";
import { formatChatTime } from "@/utils";
import { format } from "timeago.js";

interface ReviewCardProps {
  review: MerchantReview;
}

export default function ReviewCard({ review }: ReviewCardProps) {
  const initials =
    review?.reviewer?.username
      ?.split(" ")
      .map((x: string) => x[0])
      .join("")
      .slice(0, 2)
      .toUpperCase() || "U";

  return (
    <div className="rounded-2xl transition-all duration-200 hover:shadow-md">
      <div className="p-2">
        <div className="flex items-start justify-between gap-4">
          <div className="flex gap-4">
            <Avatar className="h-10 w-10 bg-primary/10 flex items-center justify-center font-semibold text-primary">
              <AvatarImage src={review?.reviewer?.avatar ?? ""} />

              <AvatarFallback>{initials}</AvatarFallback>
            </Avatar>

            <div className="">
              <div className="flex flex-wrap items-center gap-2">
                <h3 className="font-semibold">{review?.reviewer?.username}</h3>
                {/* <h3 className="font-semibold">{"Anonymous User"}</h3> */}

                {/* {review?.verified && (
                  <Badge className="rounded-full bg-primary text-[10px]">
                    <ShieldCheck className="mr-1 h-3.5 w-3.5" />
                    Verified Trade
                  </Badge>
                )} */}
              </div>
              <p className="mt-3 text-sm text-muted-foreground">
                {review?.comment}
              </p>
            </div>
          </div>

          <span className="text-sm text-muted-foreground">
            {format(review.createdAt)}
            {/* {formatChatTime(review.createdAt)} */}
          </span>
        </div>
      </div>
    </div>
  );
}
